import React from "react";

import DotsVertical from "@uui/DotsVertical";
import AccessIcon from "@uui/Key01";
import ShareIcon from "@uui/Share06";

import { useMediaQuery } from "@mui/material";
import Divider from "@mui/material/Divider";

import TableCell from "@app/analytics/components/Table/TableCell";
import theme from "@app/analytics/theme";
import { TOOLTIPS } from "@app/common/content";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import IconButton from "@rui/IconButton";
import MenuItem from "@rui/MenuItem";
import { Row } from "@rui/Stack";
import TooltipWrapper from "@rui/TooltipWrapper";

import { ActionsMenu, ShareButton } from "../styles";

const ACCESS_TEXT = "Access";
const SHARE_TEXT = "Share";

interface UpcomingEventActionsCellProps {
  canShare: boolean;
  canInviteReadToManageSharing: boolean;
  handleShareClick: () => void;
  handleAccessClick: () => void;
}

const UpcomingEventActionsCell = ({
  canInviteReadToManageSharing,
  canShare,
  handleShareClick,
  handleAccessClick,
}: UpcomingEventActionsCellProps) => {
  const isDesktopView = useMediaQuery(theme.breakpoints.up("sm"));
  const { onClick, anchorElement, open, onClose } = useAnchorElement();

  return (
    <>
      <TableCell
        sx={{
          textAlign: "center",
          width: { xxs: "auto", sm: "140px" },
          alignContent: { xxs: "start", sm: "center" },
        }}
      >
        {isDesktopView ? (
          <Row variant="left" spacing={0.5}>
            <TooltipWrapper
              show={!canShare && canInviteReadToManageSharing}
              title={TOOLTIPS.calendar.shareDisabledInviteRead}
            >
              <ShareButton
                disabled={!canShare}
                onClick={handleShareClick}
                startIcon={<ShareIcon />}
              >
                {SHARE_TEXT}
              </ShareButton>
            </TooltipWrapper>
            <Divider orientation="vertical" sx={{ height: "20px" }} />
            <TooltipWrapper
              show={!canShare && canInviteReadToManageSharing}
              title={TOOLTIPS.calendar.accessDisabledInviteRead}
            >
              <ShareButton
                disabled={!canShare}
                onClick={handleAccessClick}
                startIcon={<AccessIcon />}
              >
                {ACCESS_TEXT}
              </ShareButton>
            </TooltipWrapper>
          </Row>
        ) : (
          <IconButton onClick={onClick}>
            <DotsVertical sx={{ height: "16px", width: "16px" }} />
          </IconButton>
        )}
      </TableCell>
      <ActionsMenu
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        anchorEl={anchorElement}
        onClose={onClose}
      >
        <MenuItem
          sx={{ minHeight: 0 }}
          disabled={!canShare}
          icon={<ShareIcon />}
          onClick={handleShareClick}
        >
          {SHARE_TEXT}
        </MenuItem>
        <MenuItem
          sx={{ minHeight: 0 }}
          disabled={!canShare}
          icon={<AccessIcon />}
          onClick={handleAccessClick}
        >
          {ACCESS_TEXT}
        </MenuItem>
      </ActionsMenu>
    </>
  );
};

export default UpcomingEventActionsCell;
